<template>
  <v-card dark>
    <v-card-actions>
      <v-card-title>{{ $t('LOGOUTMESSAGE') }}</v-card-title>
      <v-spacer></v-spacer>
      <v-btn plain text @click="ChangeDialog('')">{{ $t('NO') }}</v-btn>
      <v-btn plain text color="blue lighten-2" @click="logout">{{ $t('YES') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'Logout',

  data() {
    return {}
  },

  computed: {},

  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('auth', ['setAuth']),
    ...mapActions('message', ['setSnackbar']),
    logout() {
      this.setAuth({ token: '', isLogin: false })
      this.ChangeDialog('')
      this.setSnackbar({
        show: true,
        text: 'LOGOUTSUCCESS_1',
        timeout: '1200'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
